import { UTM_MEDIUM_VALUES } from 'constants/utmMarks';

export const checkPaidTraffic = (medium?: string) =>
  UTM_MEDIUM_VALUES.PAID_TRAFFIC.includes(medium?.toLowerCase() || '');
